import { useEffect, useMemo } from "react";
import classes from "./Report.module.css";
import BoxWrapper from "../../../../../components/ui/boxWrapper";

function ProbableMatched({ probablematchedData, onTabClick, loading }) {
  useEffect(() => {
    onTabClick();
  }, [onTabClick]);

  const rows = useMemo(() => {
    if (loading) {
      return (
        <tr>
          <td colSpan={11} className={classes.loader}>
            Loading...
          </td>
        </tr>
      );
    }
    const matchedData = probablematchedData?.record?.ProbableMatching || [];

    if (!matchedData.length) {
      return (
        <tr>
          <td colSpan={17} className={classes.noData}>
            No Data Found!
          </td>
        </tr>
      );
    }

    return matchedData.map((invoice, index) => (
      <tr key={index}>
        <td style={{ color: "black" }}>{invoice.GSTIN}</td>
        <td style={{ color: "black" }}>{invoice.Vendor_Name}</td>
        <td style={{ color: "black" }}>{invoice.PR_DOC_NUMBER}</td>
        <td style={{ color: "black" }}>{invoice.GSTR6A_DOC_NUMBER}</td>
        <td style={{ color: "black" }}>{invoice.PR_DOC_DATE}</td>
        <td style={{ color: "black" }}>{invoice.GSTR6A_DOC_DATE}</td>
        <td style={{ color: "black" }}>{invoice.DOC_TYPE}</td>
        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value_Int).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.CGST_Int).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.SGST_Int).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.IGST_Int).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Cess_Int).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Invoice_Value_Int).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.CGST_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.SGST_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.IGST_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Cess_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Invoice_Value_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value_Diff).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Tax_Diff).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Amount_Diff).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>{invoice.Remarks}</td>
      </tr>
    ));
  }, [loading, probablematchedData?.record?.ProbableMatching]);

  return (
    <>
      <BoxWrapper
        searchInputPlaceholder="Search..."
        boxTitle="Reconciliation Status: Invoice(s) Matching with Intelligence"
      >
        <div className={classes.ResponsiveTable}>
          <table className={classes.missingInAccountTableCss}>
            <thead>
              <tr>
                <th rowSpan={2}>GSTIN</th>
                <th rowSpan={2} align="right">
                  VENDOR NAME
                </th>
                <th rowSpan={2} align="right">
                  PR DOC NUMBER
                </th>
                <th rowSpan={2} align="right">
                  GSTR6A DOC NUMBER
                </th>
                <th rowSpan={2} align="right">
                  PR DOC DATE
                </th>
                <th rowSpan={2} align="right">
                  GSTR6A DOC DATE
                </th>
                <th rowSpan={2} align="right">
                  DOC TYPE
                </th>
                <th
                  style={{ background: "#ffcc66" }}
                  colSpan={6}
                  align="center"
                >
                  As per Books
                </th>
                <th
                  style={{ background: "#c6ffb3" }}
                  colSpan={6}
                  align="center"
                >
                  As per GSTR6A
                </th>
                <th style={{ background: "ORANGE" }} colSpan={3} align="center">
                  Difference
                </th>
                <th style={{ background: "ORANGE" }} rowSpan={2} align="center">
                  REMARKS
                </th>
              </tr>
              <tr>
                <th style={{ background: "#ffcc66" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  CGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  SGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  IGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  CESS
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  TOTAL AMOUNT
                </th>

                <th style={{ background: "#c6ffb3" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  CGST
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  SGST
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  IGST
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  CESS
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  TOTAL AMOUNT
                </th>

                <th style={{ background: "ORANGE" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "ORANGE" }} align="right">
                  TAX
                </th>
                <th style={{ background: "ORANGE" }} align="right">
                  TOTAL AMOUNT
                </th>
              </tr>
            </thead>

            <tbody>{rows}</tbody>
          </table>
        </div>
      </BoxWrapper>
    </>
  );
}

export default ProbableMatched;
